// extracted by mini-css-extract-plugin
export default {"wrapperPage":"AboutUs_wrapperPage__mU+Y5","title":"AboutUs_title__U9-Z7","content":"AboutUs_content__wEnW2","founders":"AboutUs_founders__sBpxO"};